import useMutateNetworkElementDisableAutoSwitch from './useMutateNetworkElementDisableAutoSwitch';
import useMutateNetworkElementEnableAutoSwitch from './useMutateNetworkElementEnableAutoSwitch';
import useMutateNetworkElementsCheckIpAddress from './useMutateNetworkElementsCheckIpAddress';
import useMutateNetworkElementsCheckName from './useMutateNetworkElementsCheckName';
import useMutateNetworkElementsCheckPath from './useMutateNetworkElementsCheckPath';
import useMutateNetworkElementsConnect from './useMutateNetworkElementsConnect';
import useMutateNetworkElementsCreate from './useMutateNetworkElementsCreate';
import useMutateNetworkElementsDelete from './useMutateNetworkElementsDelete';
import useMutateNetworkElementsDisableSFTP from './useMutateNetworkElementsDisableSFTP';
import useMutateNetworkElementsEdit from './useMutateNetworkElementsEdit';
import useMutateNetworkElementsEnableSFTP from './useMutateNetworkElementsEnableSFTP';
import useMutateNetworkElementsSubscribe from './useMutateNetworkElementsSubscribe';

interface IUseMutateNetworkElementReturned {
	closeConfirmModal: () => void;
	closeNetworkElementModal: () => void;
	closeSFTPModal: () => void;
	closeAutoSwitchModal: () => void;
}

const useMutateNetworkElement = ({
	closeConfirmModal,
	closeNetworkElementModal,
	closeSFTPModal,
	closeAutoSwitchModal,
}: IUseMutateNetworkElementReturned) => {
	const {
		connectNetworkElement,
		isLoadingConnectNetworkElement,
	} = useMutateNetworkElementsConnect(closeConfirmModal);

	const {
		deleteNetworkElement,
		isLoadingDeleteNetworkElement,
	} = useMutateNetworkElementsDelete(closeConfirmModal);

	const {
		subscribeNetworkElement,
		isLoadingSubscribeNetworkElement,
	} = useMutateNetworkElementsSubscribe(closeConfirmModal);

	const {
		editNetworkElement,
		isLoadingEditNetworkElement,
	} = useMutateNetworkElementsEdit(closeNetworkElementModal);

	const {
		createNetworkElement,
		isLoadingCreateNetworkElement,
	} = useMutateNetworkElementsCreate(closeNetworkElementModal);

	const {
		handleEnableSFTP,
		isLoadingEnableSFTP,
	} = useMutateNetworkElementsEnableSFTP(closeSFTPModal);

	const {
		handleDisableSFTP,
		isLoadingDisableSFTP,
	} = useMutateNetworkElementsDisableSFTP(closeConfirmModal);

	const {
		handleCheckName,
	} = useMutateNetworkElementsCheckName();

	const {
		handleCheckIpAddress,
	} = useMutateNetworkElementsCheckIpAddress();

	const {
		handleCheckPath,
	} = useMutateNetworkElementsCheckPath();

	const {
		enableNetworkElementAutoSwitch,
		isLoadingEnableNetworkElementAutoSwitch,
	} = useMutateNetworkElementEnableAutoSwitch(closeAutoSwitchModal);

	const {
		disableNetworkElementAutoSwitch,
		isLoadingDisableNetworkElementAutoSwitch,
	} = useMutateNetworkElementDisableAutoSwitch(closeConfirmModal);

	return {
		connectNetworkElement,
		createNetworkElement,
		editNetworkElement,
		subscribeNetworkElement,
		deleteNetworkElement,
		enableNetworkElementAutoSwitch,
		disableNetworkElementAutoSwitch,
		handleCheckName,
		handleCheckIpAddress,
		handleEnableSFTP,
		handleDisableSFTP,
		handleCheckPath,
		isLoadingNetworkElementMutation: isLoadingConnectNetworkElement
			|| isLoadingDeleteNetworkElement
			|| isLoadingSubscribeNetworkElement
			|| isLoadingEditNetworkElement
			|| isLoadingEnableSFTP
			|| isLoadingDisableSFTP
			|| isLoadingCreateNetworkElement
			|| isLoadingEnableNetworkElementAutoSwitch
			|| isLoadingDisableNetworkElementAutoSwitch,
	};
};

export default useMutateNetworkElement;
